import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { ReactComponent as QMentisAILogo } from "../../images/QMentis.svg"; // Adjust the path as necessary
import "../../App.css"; // Ensure this contains the rotate-animation CSS

function ProgressWithLogo({
  message = "Getting you a quality response...",
  progress = null,
}) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding={3}
      borderRadius={1}
      bgcolor="background.paper"
      boxShadow={3}
      minWidth={250}
      border="1.5px solid black"
    //minHeight={200}
    >
      <Box
        className="rotate-animation"
        sx={{
          display: "inline-block",
          width: "70px",
          height: "70px",
        }}
        mb={1}
      >
        <QMentisAILogo width="70" height="70" />
      </Box>
      <Typography variant="h5" color="textPrimary" gutterBottom>
        QMentisAI™ - Intelligence for Next-Gen Quality
      </Typography>

      {/* Keep message centered and stack progress bar below it */}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        mt={2}
        width="100%"
      >
        <Typography
          variant="h7"
          color="textSecondary"
          align="center"
          gutterBottom
        >
          {message}
        </Typography>

        <Box sx={{ width: "150px", mt: 2 }}>
          <LinearProgress
            variant={progress !== null ? "determinate" : "indeterminate"}
            value={progress !== null ? progress : undefined}
            sx={{
              height: 5,
              borderRadius: 5,
              backgroundColor: '#e0e0e0', 
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#0094FB', 
              },
            }}
          />

        </Box>
      </Box>
    </Box>
  );
}

export default ProgressWithLogo;
